export function onCallBackKeydownback() {
   history.go(-1)
}

export function closePage() {
   let deviceSystem = checkDeviceSystem();
   if (deviceSystem == "android") {
     console.log("android system")
     CSII.closePage()
   } else if (deviceSystem == "ios") {
     console.log("ios system")
     window.webkit.messageHandlers.closePage.postMessage(null);
   } else {
     console.log("other system")
   }

}

function checkDeviceSystem(){
    let equipmentType = "";
    let agent = navigator.userAgent.toLowerCase();
    let android = agent.indexOf("android");
    let iphone = agent.indexOf("iphone");
    let ipad = agent.indexOf("ipad");
    if(android != -1){
        equipmentType = "android";
    }
    if(iphone != -1 || ipad != -1){
        equipmentType = "ios";
    }
    return equipmentType;
}



// WEBPACK FOOTER //
// ./src/common/msCallback.js